import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IIdQueryResult } from "./id-query-result";
import { Query } from "./query";
import { IQueryIterator, QueryIteratorBase } from "./query-iterator";

export type IIdIterator = IQueryIterator<IIdQueryResult>;

export class EntityIdIterator extends QueryIteratorBase<IIdQueryResult> implements IIdIterator {
    private readonly _client: IContentHubClient;

    constructor(client: IContentHubClient, query: Query, result?: IIdQueryResult) {
        super(query, result);

        Guard.notNullOrUndefined(client);
        this._client = client;
    }

    getResultAsync(query: Query): Promise<IIdQueryResult> {
        return this._client.querying.queryIdsAsync(query);
    }
}
